import Link from 'next/link';
import React, { useEffect } from 'react';
import { rankings_data } from '../../../data/rankings_data';
import Image from 'next/image';
import Recently_added_dropdown from '../../../components/dropdown/recently_added_dropdown';
import Head from 'next/head';
import Meta from '../../../components/Meta';
import { collectRenkingData } from '../../../redux/counterSlice';
import { useSelector, useDispatch } from 'react-redux';

import TimeInput from '../../../components/calc/TimeInput';
import Table from '../../../components/calc/Table';
import { textAlign } from '@mui/system';

const Index = () => {
	const { filteredRenkingData } = useSelector((state) => state.counter);
	const dispatch = useDispatch();
	const [now, setNow] = React.useState(new Date());
	const [timestamp, setTimeStamp]= React.useState(0);

	const handleDateUpdate = (time) =>{
		console.log('handle update', time);
		let unixTimestamp = new Date(time).getTime() / 1000;
		setTimeStamp(unixTimestamp);
	  }
	
	useEffect(() => {
		dispatch(collectRenkingData(rankings_data));
	}, [dispatch]);

	return (
		<>
			<Meta title="Discord Timestamp Converter" desc={"Simply input the date and time in your local timezone, and get the Discord timestamp code"} keyword={"Discord timestamp converter,Local timezone converter for Discord, Convert date and time to Discord timestamp, Dynamic timestamp for Discord messages,Discord event scheduler,Easy timestamp generator for Discord,Local time display for Discord events"}/>
			{/* <!-- Rankings --> */}
			<section className="relative mt-12 sm:mt-12 md:mt-16 lg:mt-24 lg:pb-12 pb-6">
				<picture className="pointer-events-none absolute inset-0 -z-10 dark:hidden">
					<Image
						src="/images/gradient_light.jpg"
						layout="fill"
						alt="gradient"
						className="h-full w-full"
					/>
				</picture>
				<div className="container">
					<h1 className="font-display text-jacarta-700 pt-16 text-center text-4xl font-medium dark:text-white">
					Discord Timestamp Converter
					</h1>

					
					<h3 className="font-display text-jacarta-700 py-4 text-center text-1xl font-medium dark:text-white">Simply input the date and time in your local timezone, and get the Discord timestamp code.</h3>

					{/* <!-- Table --> */}
					<TimeInput className="text-center" now={now} handleUpdate={handleDateUpdate}/>


					<h2 className="font-display text-jacarta-700 py-4 text-center text-1xl font-medium dark:text-white">
					<span className="dark:text-white text-2xl pr-2">{'Timestamp'}</span>: <span className="pl-2 text-red dark:text-red text-2xl">{timestamp}</span>
					</h2>

					<Table timestamp={timestamp}></Table>



					
					
				</div>
			</section>
			{/* <!-- end rankings --> */}
		</>
	);
};

export default Index;
